export enum State {
  NOT_SET = 0,
  ACTIVE = 1,
  INACTIVE = 2,
  TEMPORARY = 7,
  DELETED = 9,
}
